import './LandingPage.css';

const LandingPage = () => {
    localStorage.clear()
    return (
        <div>
            {/* Hero */}
            <section className="hero">
                <div className="container" style={{ marginTop: '3rem' }}>
                    <p className="lead text-center">
                        5G-Konnektivität wird in vielen Branchen – etwa Produktion und Logistik – zunehmend zum Rückgrat geschäftskritischer Anwendungen.
                        Mit dem 5G Campusnetzplaner Pro bieten wir ein intuitives, webbasiertes Planungstool, das aktuelle Forschung direkt in die industrielle Praxis bringt.
                    </p>
                    <p className="text-center" style={{ marginTop: '2rem' }}>
                        Das Tool unterstützt Unternehmen dabei, private 5G-Netze einfach und effizient zu planen – mithilfe von 3D Umgebungsmodellen, akkuraten Ausbreitungsmodellen, Radio Environmental Maps (REMs) und intelligenter Standortvorschläge für Basisstationen.
                        Dabei wird ein optimaler Ausgleich zwischen Netzqualität (QoS) und Infrastrukturkosten angestrebt.
                    </p>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginTop: '2rem' }}>
                    <a href="#beispiele" className="btn my-primary-btn m-2">Beispiele ansehen</a>
                    <a href="#contact" className="btn btn-outline-secondary my-outline-btn m-2">Kontakt</a>
                </div>
            </section>

            {/* Über das Tool */}
            <section style={{ backgroundColor: '#F5F5F5', padding: '40px 0 60px 0', marginTop: '3rem', marginBottom: '3rem' }}>
                <div className="container" pb-2>
                    <h2 className="section-title text-center pb-4">Was ist der Campusnetzplaner Pro?</h2>
                    <p className="text-center">
                        Der 5G Campusnetzplaner Pro wurde am Lehrstuhl für Kommunikationsnetze der TU Dortmund
                        entwickelt und basiert auf neuesten Forschungsergebnissen im Bereich der automatisierten Netzplanung.
                        Ziel ist es, die Planung privater 5G-Netze mit wenigen Schritten zugänglich und nachvollziehbar zu machen.
                    </p>
                    <ul style={{ width: '500px', margin: '0 auto', paddingLeft: 0 }}>
                        <li>Webbasiertes, kostenfrei zugängliches Tool</li>
                        {/* <li>KI-gestützte Planung mit Deep-Learning-Ausbreitungsmodellen</li> */}
                        <li>Automatische Generierung von REMs und Antennenplatzierung</li>
                        <li>Praxisnahe Szenarien aus Industrie, Logistik und Forschung</li>
                    </ul>
                </div>
                <div className="video-container text-center pt-6">
                    <iframe 
                        width="560" 
                        height="315" 
                        src="https://www.youtube.com/embed/XtqOewTqgSw?si=fBt5d_KMvt5DEva3" 
                        title="YouTube video player" 
                        frameborder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        referrerpolicy="strict-origin-when-cross-origin" 
                        allowfullscreen>
                    </iframe>
                </div>
            </section>

            {/* Beispielplanungen */}
            <section id="beispiele" className="container my-5 pb-4 pt-2">
                <h2 className="section-title text-center pb-3">Beispielplanungen</h2>
                <div className="row g-4 justify-content-center">
                    {[
                        // {
                        //     title: "Produktionshalle",
                        //     text: "Planung eines 5G-Netzes zur drahtlosen Maschinensteuerung mit Fokus auf Zuverlässigkeit trotz Metallabschirmung.",
                        //     url: "https://campusnetzplaner-pro.kn.e-technik.tu-dortmund.de/bdcfc4af-e9a7-4a1c-8c6f-5bd1687fcd96"
                        // },
                        {
                            title: "Logistiklager",
                            text: "Optimale Versorgung für automatisierte Transportsysteme auf großen Flächen mit niedriger Latenz.",
                            url: "/logistiklager"
                        },
                        {
                            title: "Campusgelände",
                            text: "Flächendeckende Versorgung für Institute und Außenanlagen – auch mit mehreren Gebäudetypen und Nutzungszonen.",
                            url: "/campusgelaende"
                        }
                    ].map(({ title, text, url }) => (
                        <div key={title} className="col-md-4">
                            <a href={url} className="card h-100 clickable-card text-decoration-none text-dark">
                                <div className="card-body d-flex flex-column">
                                    <h5 className="card-title text-center">{title}</h5>
                                    <p className="card-text text-center" style={{ fontWeight: 300 }}>{text}</p>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </section>

            {/* Über das Tool */}
            <section id="contact" style={{ backgroundColor: '#F5F5F5', padding: '40px 0 60px 0', marginTop: '3rem', marginBottom: '3rem' }}>
                <div className="container">
                    <h2 className="section-title text-center pb-4">Planen Sie ihr eigenes 5G-Campusnetz</h2>
                    <p className="text-center">
                        Mit dem 5G Campusnetzplaner Pro unterstützen wir Sie bei der effizienten Planung Ihres individuellen Campusnetzes.
                        Das Tooling steht Ihnen gerne auf Anfrage zur Verfügung.
                        Wenn Sie Interesse haben, senden Sie uns einfach eine kurze Nachricht – wir melden uns umgehend bei Ihnen.
                        {/* mailto:campusnetzplanerpro.kn.etit@tu-dortmund.de */}
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginTop: '2rem' }}>
                        <a href="mailto:campusnetzplanerpro.kn.etit@tu-dortmund.de" className="btn my-primary-btn m-2">Kontakt aufnehmen</a>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default LandingPage;